/* RESPONSIBLE TEAM: team-self-serve */
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';

export default class GuideLibraryIndexController extends Controller {
  queryParams = [];

  @service declare appService: any;
}
